import ProductForm from '@/modules/product-form';
import '@/modules/pdp-quick-add/pdp-quick-add.scss';
import '@/modules/product-form/product.scss';

if (document.getElementsByTagName('product-form')) {
    if(!customElements.get('product-form')) {
        customElements.define('product-form', ProductForm);
    }
}